import React, { useState, useEffect } from 'react';
import Highcharts, { chart } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { moneyFormatter } from '../../helper';
import { title } from '../../constant/title';

HighchartsMore(Highcharts);

const BarChart = ({ data }) => {
  const [result, setResult] = useState([]);

  useEffect(() => {
    let res = [];
    data.result.map((item) => {
      res.push({
        name: item.name,
        data: [parseInt(item.data)],
      });
    });

    setResult(res);
  }, []);

  const options = {
    chart: {
      type: 'column',
      renderTo: 'chart1',
      height: 320,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: `Grafik ${title(data.metric)}`,
    },
    xAxis: { visible: false },
    yAxis: {
      title: {
        text: 'Harga Kendaraan',
      },
      labels: {
        formatter: function () {
          return moneyFormatter(this.value);
        },
      },
    },
    plotOptions: {
      series: { pointStart: 1 },
      yAxis: 1,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const {
          y,
          series: { name },
        } = this.point;
        return (
          `<span style="font-size:12px; font-weight: bold">GRADE ${name}</span><br />` +
          `<span style="font-size:12px;">Rp. ${moneyFormatter(y)}</span>`
        );
      },
    },
    series: [...result],
    legend: { enabled: true },
    credits: { enabled: false },
  };

  return (
    <div id="chart1">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default BarChart;
